<a class="text-blue-500 underline" routerLink="{{base()}}/{{id()}}">{{id()}}</a>
